import React from "react";

import MobileCanvas from "../../components/MobileCanvas";

import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(
  () => ({
    root: {
      height: "100%",
      width: "100%"
    }
  }),
  { name: "MobileStepFour" }
);

export default function MobileStepFour() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <MobileCanvas />
    </div>
  );
}
